import * as types from '../constants/ActionTypes';
import * as notifier from '../constants/NotifierTypes';

const initialState = {
  type: 'loader',
  display: false,
  details: notifier.pageIsUnavailable,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SEND_EMAIL:
    case types.REQUEST_ARTICLE_SEARCH:
      return { ...state, type: 'loader', display: true };
    case types.RECEIVE_EMPTY_FIELDS:
      return { ...state, type: 'error', display: true };
    case types.RECEIVE_EMAIL_ERROR:
      return {
        ...state, type: 'error', display: true, details: action.payload,
      };
    case types.RECEIVE_EMAIL_RESPONSE:
    case types.RECEIVE_EMAIL_RESPONSE_NO_INTENT:
      return {
        ...state, type: 'info', display: true, details: action.payload,
      };
    case types.REQUEST_CALLUS:
    case types.RECEIVE_ARTICLE_SEARCH_RESPONSE:
    case types.RECEIVE_ARTICLE_SEARCH_ERROR:
      return { ...state, display: false };
    default:
      return state;
  }
}
